import { Fallback as FallbackComponent } from "@q4/nimbus-ui";
import React, { memo } from "react";
import config from "../../../../config";

const Fallback = (): JSX.Element => {
  return <FallbackComponent email={config.errorEmail} />;
};

export default memo(Fallback);
